import React from 'react';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles(() => ({
    linkArrow: {
        width: '1.25rem',
        height: '1.25rem',
        transform: 'rotate(0)',
        transition: 'transform 300ms',
    }
}))

export const LinkArrowHoverStyle = {
    transform: 'rotate(45deg)',
}

export default ({fill, stroke}: {fill?: string, stroke?: string}) => {
    const classes = useStyles();
    const size = 40;
    const side = 10;
    const width = 3;
    const margin = 10;
    const path = [
        `M${margin+width} ${size-margin-width}`,
        `L${size-margin-width} ${margin+width}`,
        `l0 ${side}`,
        `M${size-margin-width} ${margin+width}`,
        `l${-side} 0`,
    ].join(' ');
    return (
        <svg viewBox={`0 0 ${size} ${size}`} className={classes.linkArrow}>
            <g>
                <circle stroke="none" fill={fill || '#0e151d'} r={size / 2} cx={size / 2} cy={size / 2} />
                <path
                    strokeWidth={width}
                    fill='none'
                    stroke={stroke || 'white'}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d={path}
                />
            </g>
        </svg>
    );
}
